import React from 'react';

import { ReactComponent as CircleSvg } from '@assets/svg/map-marker/circle.svg';
import { ReactComponent as RhombusSvg } from '@assets/svg/map-marker/rhombus.svg';
import { ReactComponent as SquareSvg } from '@assets/svg/map-marker/square.svg';
import { ReactComponent as StarSvg } from '@assets/svg/map-marker/star.svg';
import { ReactComponent as TriangleSvg } from '@assets/svg/map-marker/triangle.svg';

import style from './style.module.scss';

const svgElement = {
  circle: { Svg: CircleSvg, size: '18', transform: 'translate(-9, -9)' },
  star: { Svg: StarSvg, size: '20', transform: 'translate(-10, -10)' },
  triangle: { Svg: TriangleSvg, size: '18', transform: 'translate(-9, -9)' },
  square: { Svg: SquareSvg, size: '20', transform: 'translate(-10, -10)' },
  rhombus: { Svg: RhombusSvg, size: '20', transform: 'translate(-10, -10)' },
};

const MapMarkerSvg = ({ type, variant = 'circle', color = '#3AB1C9', isVisible = true, onClick }) => {
  const renderSvg = svgElement[variant];

  if (!isVisible) {
    return null;
  }

  return type === 'mapMarker' ? (
    <g
      transform={renderSvg.transform}
      cursor="pointer"
      onClick={() => onClick && onClick()}
      className={style.mapMarkerWrapper}
    >
      <renderSvg.Svg width={renderSvg.size} height={renderSvg.size} fill={color} />
    </g>
  ) : (
    <renderSvg.Svg fill={color} className={style.mapMarker} />
  );
};

export default MapMarkerSvg;
